<template>
  <v-dialog v-model="open" persistent max-width="700">
    <v-card class="align-center text-center">
      <v-card-text>
        <div class="pt-5 d-flex align-center justify-space-between">
          <h1>Atualizar Nº do Chamado</h1>
          <v-btn icon @click="close()" class="align-self-end">
            <v-icon> mdi-close </v-icon>
          </v-btn>
        </div>

        <div class="mt30"></div>
        <v-form ref="aditionalForm">
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="numChamado" label="Número do chamado" :rules="rules"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <div class="mt10"></div>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between pb-5">
        <v-btn color="error" class="flex-grow-1" large @click="close()"> Cancelar </v-btn>
        <v-btn color="success" class="flex-grow-1" large @click="updateNumber()"> Confirmar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'UpdateNumber',
  data: () => ({
    numChamado: '',
    ids: [],
    message: [],
    rules: [(value) => !!value || 'Required.']
  }),
  props: {
    open: {
      default: false,
      type: Boolean
    },
    nfeSelectedId: {
      default: Number
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.getNumber();

        if (this.$refs.aditionalForm) {
          this.$refs.aditionalForm.reset();
        }
      }
    }
  },
  methods: {
    ...mapActions('QuarantineStore', ['setQuarantineNumber', 'getQuarantineNumber']),

    async getNumber() {
      const num = await this.getQuarantineNumber(this.nfeSelectedId);
      if (num) this.numChamado = num;
      else this.numChamado = null;
    },
    close(message) {
      this.$emit('closeUpdateNumber', message);
      this.numChamado = '';
    },
    async updateNumber() {
      if (!this.numChamado) {
        this.numChamado = null;
        return;
      }
      var model = {
        id: this.nfeSelectedId,
        number: this.numChamado
      };

      try {
        const data = await this.setQuarantineNumber(model);

        if (data.success) {
          this.message = {
            errors: ['O Número do Chamado foi atualizado com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: data.errors,
            errorsType: 'error'
          };
        }
      } catch (e) {
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error',
          error500: e
        };
      } finally {
        this.close(this.message);
      }
    }
  }
};
</script>

<style></style>
